import React from 'react';
import './singleSelect.sass';
// import PropTypes from 'prop-types';

/* Component for single select question types.
Takes in a question,
maps through the answer list and displays all possible answers */
const SingleSelect = ({ question, onChange, value, user, joinCode }) => {
  function handleAnswer(event) {
    const index = event.target.value.split(',')[0];
    const text = event.target.value.split(',')[1];
    onChange({ value: index, text }, question.questionID, question.questionLevel);
  }

  // removes numbered list present in this question type
  if (question.questionType === 'INTRO_MESSAGE_MULTIPLE_CHOICE') {
    question.questionText = question.questionText
      .replace(/\d+:\s+\w+\n?/g, '')
      .replace(/\/\s*NDIO\s*\/\s*HAPANA\s*\/\s*SITISHA/gi, '')
      .replace(/\{user\}/gi, user);
  }

  // Linkify URLs in question text
  const linkifiedQuestionText = question.questionText.replace(
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
    "<a href='$1' target='_blank' >here</a>",
  );

  const isDropdownQuestion = question.questionID === 691160 || question.questionID === 691440;
  const isInlineRating = joinCode === 'ZTDSDF';

  return (
    <div className="single-select">
      <h4 className="range-score-question">
        <p
          className="question-text"
          dangerouslySetInnerHTML={{
            __html: linkifiedQuestionText.replace(/\/n/g, '<br/>'),
          }}
        />
      </h4>
      <div className="answer-list">
        {/* ---- DROPDOWN FOR QUESTION ID 691160 / 691440 ---- */}
        {isDropdownQuestion ? (
          <select
            className="simple-dropdown"
            style={{ width: '100%', height: '38px', fontSize: '14px' }}
            onChange={(e) => {
              const index = e.target.value;
              const text = question.answerList[index - 1];
              onChange({ value: index, text }, question.questionID, question.questionLevel);
            }}
            value={value || ''}
          >
            <option value="">Select an option</option>
            {question?.answerList?.map((option, index) => (
              <option key={`${question.questionID}${index}`} value={index + 1}>
                {option}
              </option>
            ))}
          </select>
        ) : isInlineRating ? (
          /* ---- INLINE RATING FOR JOINCODE Y7U6SP ---- */
          <div className="inline-rating">
            {question?.answerList
              ?.slice(
                0,
                question.questionID === 682034 || question.questionID === 690803 ? -1 : undefined,
              )
              .map((option, index) => (
                <div key={`${question.questionID}${index}`} className="rating-btn">
                  <input
                    type="radio"
                    id={`${question.questionID}${index}`}
                    value={[index + 1, option]}
                    onChange={handleAnswer}
                    checked={(index + 1).toString() === value}
                  />
                  <label htmlFor={`${question.questionID}${index}`}>{option}</label>
                </div>
              ))}
          </div>
        ) : (
          /* ---- DEFAULT STACKED RADIO BUTTONS ---- */
          <>
            {question &&
              question.answerList &&
              question.answerList
                .slice(
                  0,
                  question.questionID === 682034 || question.questionID === 690803 ? -1 : undefined,
                )
                .map((option, index) => (
                  <div key={`${question.questionID}${index}`} className="radio-btn">
                    <input
                      type="radio"
                      id={`${question.questionID}${index}`}
                      value={[index + 1, option]}
                      onChange={handleAnswer}
                      checked={(index + 1).toString() === value}
                    />
                    <label className="answer" htmlFor={`${question.questionID}${index}`}>
                      {option}
                    </label>
                  </div>
                ))}
          </>
        )}
      </div>
    </div>
  );
};

// SingleSelect.propTypes = {
//   onChange: PropTypes.func.isRequired,
//   value: PropTypes.string.isRequired,
//   question: PropTypes.objectOf(PropTypes.any).isRequired,
// };

export default SingleSelect;
